import { Flex, Box } from "@chakra-ui/react";
import Navbar, { NAV_COLLAPSED_WIDTH, NAV_EXPANDED_WIDTH } from "./Navbar";
import { useLayout } from "../context/LayoutContext";
import { useUser } from "../context/UserContext";

const Layout = ({ children }) => {
  const { isNavPinned } = useLayout();
  const { user } = useUser();

  if (!user) {
    return <>{children}</>;
  }

  const navWidth = isNavPinned ? NAV_EXPANDED_WIDTH : NAV_COLLAPSED_WIDTH;

  return (
    <Flex>
      <Navbar />
      <Box
        as={Flex}
        direction="column"
        flex="1"
        w={{ base: "100%", lg: `calc(100% - ${navWidth})` }}
        maxW="100%"
        minW={0}
        overflowX="hidden"
        ml={{ base: 0, lg: navWidth }}
        transition="margin-left 0.3s ease-in-out"
      >
        {children}
      </Box>
    </Flex>
  );
};

export default Layout;
